import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=2068d19e&scoped=true&"
import script from "./changePassword.js?vue&type=script&lang=js&"
export * from "./changePassword.js?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=2068d19e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068d19e",
  null
  
)

export default component.exports